__turbopack_context__.v({
  "card-background": "CardSideFront-module-scss-module__qUy8Ia__card-background",
  "card-background--mobile": "CardSideFront-module-scss-module__qUy8Ia__card-background--mobile",
  "card-front": "CardSideFront-module-scss-module__qUy8Ia__card-front",
  "content-container": "CardSideFront-module-scss-module__qUy8Ia__content-container",
  "hide-desk": "CardSideFront-module-scss-module__qUy8Ia__hide-desk",
  "hide-mobile": "CardSideFront-module-scss-module__qUy8Ia__hide-mobile",
  "image-container": "CardSideFront-module-scss-module__qUy8Ia__image-container",
  "plus-icon": "CardSideFront-module-scss-module__qUy8Ia__plus-icon",
});
